import React, { ComponentProps } from "react";
import {
    ListItem,
    ListItemAvatar,
    Avatar,
    ListItemText,
    useTheme,
    TypographyProps,
    ListItemButton,
} from "@mui/material";

import makeStyles from "@mui/styles/makeStyles";

export enum VListItemType {
    Primary = "Primary",
    Secondary = "Secondary",
    White = "White",
}

type ListItemPropType = Omit<ComponentProps<typeof ListItem>, "button"> & { button?: boolean };

type VListItemProps = ListItemPropType & {
    type?: VListItemType;
    children?: React.ReactNode;
    avatar?: React.ReactNode;
    primaryText?: string;
    secondaryText?: string;
    textProps?: TypographyProps;
    textStyle?: React.CSSProperties;
};

export const VListItem: React.FC<VListItemProps> = (props: VListItemProps) => {
    const { avatar, primaryText, secondaryText, type, children, textProps, button, ...rest } = props;
    const theme = useTheme();

    const getListAvatarBackground = () => {
        if (type === VListItemType.Primary) {
            return theme.palette.primary.main;
        } else if (type === VListItemType.Secondary) {
            return theme.palette.secondary.dark;
        } else if (type === VListItemType.White) {
            return theme.palette.common.white;
        }
        return theme.palette.common.white;
    };

    const useStyles = makeStyles(() => ({
        defaultColour: {
            backgroundColor: getListAvatarBackground(),
        },
    }));

    const classes = useStyles();

    const content = (
        <>
            {avatar && (
                <ListItemAvatar>
                    <Avatar className={classes.defaultColour}>{avatar}</Avatar>
                </ListItemAvatar>
            )}
            {/* eslint-disable-next-line @typescript-eslint/no-explicit-any */}
            <ListItemText primaryTypographyProps={textProps as any} primary={primaryText} secondary={secondaryText} />
            {children}
        </>
    );

    if (button) {
        return (
            <ListItem disablePadding {...rest}>
                <ListItemButton>{content}</ListItemButton>
            </ListItem>
        );
    }

    return <ListItem {...rest}>{content}</ListItem>;
};
